import { useEffect, useState } from 'react';
import { Player, Screen, MatchResult } from './types';
import UsernameScreen from './components/UsernameScreen';
import MainMenu from './components/MainMenu';
import WeaponSelect from './components/WeaponSelect';
import GameScreen from './components/GameScreen';
import GameOverScreen from './components/GameOverScreen';
import Leaderboard from './components/Leaderboard';

const STORAGE_KEY = 'target-rush-player';

export default function App() {
  const [player, setPlayer] = useState<Player | null>(null);
  const [screen, setScreen] = useState<Screen>('username');
  const [weaponId, setWeaponId] = useState<string>('glock');
  const [lastResult, setLastResult] = useState<MatchResult | null>(null);
  const [checkedStorage, setCheckedStorage] = useState(false);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) {
        const stored: Player = JSON.parse(raw);
        setPlayer(stored);
        setScreen('menu');
      }
    } catch {
      // ignore corrupt storage
    } finally {
      setCheckedStorage(true);
    }
  }, []);

  function handleRegistered(p: Player) {
    setPlayer(p);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(p));
    setScreen('menu');
  }

  if (!checkedStorage) {
    return <div className="app-root" />;
  }

  return (
    <div className="app-root">
      {screen === 'username' && <UsernameScreen onDone={handleRegistered} />}

      {screen === 'menu' && player && (
        <MainMenu
          username={player.username}
          onPlay={() => setScreen('weaponSelect')}
          onLeaderboard={() => setScreen('leaderboard')}
        />
      )}

      {screen === 'weaponSelect' && (
        <WeaponSelect
          onConfirm={(id) => {
            setWeaponId(id);
            setScreen('game');
          }}
          onBack={() => setScreen('menu')}
        />
      )}

      {screen === 'game' && player && (
        <GameScreen
          player={player}
          weaponId={weaponId}
          onFinished={(result) => {
            setLastResult(result);
            setScreen('gameOver');
          }}
        />
      )}

      {screen === 'gameOver' && lastResult && (
        <GameOverScreen
          result={lastResult}
          onPlayAgain={() => setScreen('weaponSelect')}
          onMenu={() => setScreen('menu')}
          onLeaderboard={() => setScreen('leaderboard')}
        />
      )}

      {screen === 'leaderboard' && <Leaderboard onBack={() => setScreen(player ? 'menu' : 'username')} />}
    </div>
  );
}
